import { Button, Grid } from "@mui/material";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import {
  FormikDisabler,
  FullWidthField,
  Panel,
  usePermissions,
} from "@poseidon/ui/components";
import FullWidthForm from "@poseidon/ui/components/form/FullWidthForm";
import { Field, Formik, useFormikContext } from "formik";
import { useSaveTags } from "../hooks/useSaveTags";

const AgreementTagsWrapper = ({ agreement }) => {
  const { canWrite } = usePermissions();
  const { setError } = useErrorMessage();
  const { saveTags, saving } = useSaveTags();

  return (
    <Formik
      initialValues={{
        bankFunder: agreement?.bankFunder ?? "",
        blockNumber: agreement?.blockNumber ?? "",
      }}
      enableReinitialize
      onSubmit={async (values) => {
        try {
          await saveTags({ agreementId: agreement.id, values });
        } catch (error) {
          console.error(error);
          setError(error.message);
        }
      }}
    >
      <FullWidthForm>
        <FormikDisabler disabled={!canWrite} />
        <AgreementTags saving={saving} canWrite={canWrite} />
      </FullWidthForm>
    </Formik>
  );
};

const AgreementTags = ({ saving, canWrite }) => {
  const { dirty } = useFormikContext();
  return (
    <Panel
      expandable
      title="Agreement Tags"
      actions={
        <Button
          size="small"
          type="submit"
          disabled={!dirty || saving || !canWrite}
        >
          Save
        </Button>
      }
    >
      <Grid container spacing={2} mt={0}>
        <Grid item xs={12} sm={6}>
          <Field
            component={FullWidthField}
            name="bankFunder"
            label="Bank Funder"
            margin="none"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            component={FullWidthField}
            name="blockNumber"
            label="Block Number"
            margin="none"
          />
        </Grid>
      </Grid>
    </Panel>
  );
};

export default AgreementTagsWrapper;
